{
  "id": "campaign-133",
  "name": "Home Turf",
  "seed": "campaign:133",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "...:a......a:...",
    ".a.:..a..a..:.a.",
    "...::::::::::...",
    "..,.............",
    ".a,.a.a,.a.a..a.",
    "..,....,,.......",
    "..#...a..a.,...,",
    "..........,,,.,.",
    "::::::::::::::::",
    ".............#..",
    "..............~.",
    ".....a....a..~~~",
    "......a..a....~.",
    "...::::::::::...",
    "...:.....#..:...",
    "...:#.......:...",
    "S.....QQQQ......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 8,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 15,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 5,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 6
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "repair",
      "x": 10,
      "y": 1
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 13
  },
  "generatorVersion": 3,
  "level": 133,
  "biome": "stadium",
  "par": {
    "reel": 9666,
    "push": 8391,
    "selfPropelled": 7776,
    "tractor": 6430,
    "zeroTurn": 5424,
    "fairway": 3898
  },
  "goldTime": {
    "reel": 9576,
    "push": 8222,
    "selfPropelled": 7776,
    "tractor": 6430,
    "zeroTurn": 5424,
    "fairway": 3387
  },
  "routeTries": {
    "par": {
      "reel": 7,
      "push": 14,
      "selfPropelled": 19,
      "tractor": 9,
      "zeroTurn": 12,
      "fairway": 14
    },
    "gold": {
      "reel": 41,
      "push": 40,
      "selfPropelled": 19,
      "tractor": 9,
      "zeroTurn": 12,
      "fairway": 43
    }
  }
}
